/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import {
  HelpCircle,
  Check,
  CheckCircle,
  Send,
  User,
  Mail,
  AlertCircle,
  RotateCw,
  Award,
  BookOpen,
  ChevronDown,
  ChevronUp,
  Trash2,
  Plus
} from "lucide-react";
import Cookies from "js-cookie";
import Loader from "../Components/Loader";

export default class SoruGonder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [
        {
          id: Date.now(),
          question_text: "",
          option_a: "",
          option_b: "",
          option_c: "",
          option_d: "",
          correct_answer: "",
          isOpen: true,
        },
      ],
      honeypot: "",
      captchaSeed: "",
      captchaDifficulty: 3,
      captchaToken: "",
      isSubmitting: false,
      submitSuccess: false,
      submitError: "",
      errors: {},
      agreedToClarification: false,
      cooldownSeconds: 0,
    };
  }

  componentDidMount() {
    if (!Cookies.get("token")) {
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      window.location.href = "/login";
      return;
    }
    this.fetchCaptcha();
  }

  componentWillUnmount() {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
  }

  startCooldown = (seconds) => {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
    this.setState({ cooldownSeconds: seconds });
    this.cooldownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.cooldownSeconds <= 1) {
          clearInterval(this.cooldownInterval);
          this.cooldownInterval = null;
          return { cooldownSeconds: 0 };
        }
        return { cooldownSeconds: prevState.cooldownSeconds - 1 };
      });
    }, 1000);
  };

  fetchCaptcha = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/game-questions/captcha`
      );
      const data = await response.json();
      if (data.message === "basarili") {
        this.setState({
          captchaSeed: data.seed,
          captchaDifficulty: data.difficulty,
          captchaToken: data.token,
        });
      }
    } catch (e) {
      console.error("Captcha fetch failed", e);
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: "",
      },
    });
  };

  handleQuestionInputChange = (id, e) => {
    const { name, value } = e.target;
    this.setState({
      questions: this.state.questions.map((q) =>
        q.id === id ? { ...q, [name]: value } : q
      ),
      errors: {
        ...this.state.errors,
        [`q_${id}_${name}`]: "",
      },
    });
  };

  handleSelectCorrectAnswer = (id, optionLetter) => {
    this.setState({
      questions: this.state.questions.map((q) =>
        q.id === id ? { ...q, correct_answer: optionLetter } : q
      ),
      errors: {
        ...this.state.errors,
        [`q_${id}_correct_answer`]: "",
      },
    });
  };

  addQuestion = () => {
    const newId = Date.now();
    const newQuestion = {
      id: newId,
      question_text: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_answer: "",
      isOpen: true,
    };
    this.setState(
      {
        questions: [
          ...this.state.questions.map((q) => ({ ...q, isOpen: false })),
          newQuestion,
        ],
      },
      () => {
        setTimeout(() => {
          const el = document.getElementById(`q_card_${newId}`);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
      }
    );
  };

  removeQuestion = (id) => {
    if (this.state.questions.length <= 1) return;
    this.setState({
      questions: this.state.questions.filter((q) => q.id !== id),
    });
  };

  toggleQuestionOpen = (id) => {
    this.setState({
      questions: this.state.questions.map((q) =>
        q.id === id ? { ...q, isOpen: !q.isOpen } : q
      ),
    });
  };

  validateForm = () => {
    const { questions, agreedToClarification } = this.state;
    const errors = {};
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

    questions.forEach((q) => {
      const qPrefix = `q_${q.id}_`;
      const questionText = (q.question_text || "").trim();

      if (!questionText) {
        errors[`${qPrefix}question_text`] = "Soru metni zorunludur";
      } else if (urlRegex.test(questionText)) {
        errors[`${qPrefix}question_text`] = "Soru metninde link bulunamaz!";
      }

      const options = ["a", "b", "c", "d"];
      options.forEach((opt) => {
        const val = (q[`option_${opt}`] || "").trim();
        if (!val) {
          errors[`${qPrefix}option_${opt}`] = `${opt.toUpperCase()} şıkkı zorunludur`;
        } else if (urlRegex.test(val)) {
          errors[`${qPrefix}option_${opt}`] = `${opt.toUpperCase()} şıkkında link bulunamaz!`;
        }
      });

      const correctAnswer = (q.correct_answer || "").trim();
      if (!correctAnswer) {
        errors[`${qPrefix}correct_answer`] = "Doğru cevabı seçmelisiniz";
      }
    });



    if (!agreedToClarification) {
      errors.agreedToClarification = "Lütfen devam etmeden önce İletişim Formu Aydınlatma Metni'ni onaylayın.";
    }

    if (Object.keys(errors).length > 0) {
      const errorQuestionIds = new Set();
      Object.keys(errors).forEach((key) => {
        if (key.startsWith("q_")) {
          const parts = key.split("_");
          errorQuestionIds.add(Number(parts[1]));
        }
      });

      if (errorQuestionIds.size > 0) {
        const firstErrorId = Array.from(errorQuestionIds)[0];
        this.setState(
          {
            questions: this.state.questions.map((q) =>
              errorQuestionIds.has(q.id) ? { ...q, isOpen: true } : q
            ),
            errors,
          },
          () => {
            setTimeout(() => {
              const el = document.getElementById(`q_card_${firstErrorId}`);
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }, 100);
          }
        );
      } else {
        this.setState({ errors }, () => {
          setTimeout(() => {
            const el = document.getElementById("clarification_checkbox_container");
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 100);
        });
      }
      return false;
    }

    this.setState({ errors });
    return true;
  };

  solvePoW = async (seed, difficulty) => {
    const targetPrefix = "0".repeat(difficulty);
    let nonce = 0;
    const encoder = new TextEncoder();
    while (true) {
      const data = seed + nonce;
      const msgBuffer = encoder.encode(data);
      const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
      if (hashHex.startsWith(targetPrefix)) {
        return nonce;
      }
      nonce++;
      if (nonce > 100000) return -1;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({
      isSubmitting: true,
      submitError: "",
      submitSuccess: false,
    });

    try {
      const {
        questions,
        honeypot,
        captchaToken,
        captchaSeed,
        captchaDifficulty,
      } = this.state;

      let solvedAnswer = "";
      if (captchaSeed) {
        const nonce = await this.solvePoW(captchaSeed, captchaDifficulty);
        solvedAnswer = String(nonce);
      }

      const token = Cookies.get("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/game-questions/submit-bulk`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            questions: questions.map((q) => ({
              question_text: q.question_text,
              option_a: q.option_a,
              option_b: q.option_b,
              option_c: q.option_c,
              option_d: q.option_d,
              correct_answer: q.correct_answer,
            })),
            honeypot,
            captcha_answer: solvedAnswer,
            captcha_token: captchaToken,
          }),
        }
      );

      const data = await response.json();

      if (data.message === "basarili") {
        this.setState({
          isSubmitting: false,
          submitSuccess: true,
          submitError: "",
          questions: [
            {
              id: Date.now(),
              question_text: "",
              option_a: "",
              option_b: "",
              option_c: "",
              option_d: "",
              correct_answer: "",
              isOpen: true,
            },
          ],
          honeypot: "",
          agreedToClarification: false,
        });
        this.fetchCaptcha();
      } else {
        let errorMessage = "Soru gönderilemedi. Lütfen tekrar deneyin.";
        let shouldRefreshCaptcha = false;

        switch (data.message) {
          case "gecersizcaptcha":
            errorMessage = "Güvenlik doğrulaması başarısız. Lütfen tekrar deneyin.";
            shouldRefreshCaptcha = true;
            break;
          case "captchazamanasimi":
            errorMessage = "Güvenlik doğrulaması zaman aşımına uğradı veya çok hızlı gönderildi. Lütfen tekrar deneyin.";
            shouldRefreshCaptcha = true;
            break;
          case "linktespitadildi":
            errorMessage = "Güvenlik nedeniyle soru ve şıklarda link (URL) bulunamaz.";
            break;
          case "soruuzunluk":
            errorMessage = "Soru en az 1 karakter olmalıdır.";
            break;
          case "secenekuzunluk":
            errorMessage = "Şıklar en fazla 500 karakter olmalıdır.";
            break;
          case "eksiksecenek":
            errorMessage = "Lütfen tüm şıkları doldurun.";
            break;
          case "gecersizdogrucevap":
            errorMessage = "Geçersiz doğru cevap seçimi.";
            break;
          case "limit_exceeded":
            errorMessage = "1 dakikada en fazla 2 soru gönderebilirsiniz. Lütfen limitinizin sıfırlanmasını bekleyin.";
            if (data.retry_after) {
              this.startCooldown(data.retry_after);
            }
            break;
          case "cokfazlaistek":
            errorMessage = "Çok fazla soru gönderdiniz. Saatte en fazla 5 soru gönderebilirsiniz.";
            break;
          case "servererror":
            errorMessage = "Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.";
            break;
          default:
            errorMessage = "Bir hata oluştu. Lütfen bilgilerinizi kontrol edip tekrar deneyin.";
        }

        this.setState({
          isSubmitting: false,
          submitError: errorMessage,
        });

        if (shouldRefreshCaptcha) {
          this.fetchCaptcha();
        }
      }
    } catch (error) {
      this.setState({
        isSubmitting: false,
        submitError: "Bağlantı hatası. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.",
      });
    }
  };


  render() {
    const {
      questions,
      honeypot,
      isSubmitting,
      submitSuccess,
      submitError,
      errors,
      agreedToClarification,
      cooldownSeconds,
    } = this.state;

    const categories = [
      "Genel Kültür",
      "Tarih",
      "Coğrafya",
      "Spor",
      "Sanat & Sinema",
      "Popüler Kültür",
      "Bilim & Teknoloji",
      "Diğer",
    ];

    const hasAnyInput = questions.some(q => 
      (q.question_text || "").trim().length > 0 || 
      (q.option_a || "").trim().length > 0 || 
      (q.option_b || "").trim().length > 0 || 
      (q.option_c || "").trim().length > 0 || 
      (q.option_d || "").trim().length > 0 ||
      (q.correct_answer || "").length > 0
    );

    if (!Cookies.get("token")) {
      return null;
    }

    return (
      <>
        <Loader />
        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") == null ? false : true}
          userName="Mehmet Özkan"
        />

        <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
          {/* Header Banner */}
          <div
            style={{
              background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
              padding: "80px 0 60px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.05) 50%, transparent 70%)",
                pointerEvents: "none",
              }}
            />
            <div className="container" style={{ position: "relative", zIndex: 1 }}>
              <div className="text-center">
                <h1
                  style={{
                    color: "white",
                    fontSize: "40px",
                    fontWeight: "800",
                    marginBottom: "20px",
                  }}
                >
                  Örnek Soru Gönder
                </h1>
                <p
                  style={{
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "17px",
                    maxWidth: "700px",
                    margin: "0 auto",
                    lineHeight: "1.6",
                  }}
                >
                  Bilginizle oyunumuza imzanızı atın! Kendi hazırladığınız 4 şıklı çoktan seçmeli 
                  soruları bu form aracılığıyla bizimle paylaşabilirsiniz. Editör onayından geçen 
                  sorular oyunda yerini alacaktır!
                </p>
              </div>
            </div>
          </div>

          {/* Form Content Area */}
          <div style={{ padding: "60px 0" }}>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div
                    style={{
                      background: "#ffffff",
                      borderRadius: "24px",
                      padding: "40px",
                      boxShadow: "0 20px 50px rgba(0, 0, 0, 0.05)",
                      border: "1px solid rgba(226, 232, 240, 0.8)",
                    }}
                  >
                    <div style={{ marginBottom: "25px" }}>
                      <h3 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", marginBottom: "8px" }}>
                       Soru Detayları
                      </h3>
                      <p style={{ color: "#64748b", fontSize: "15px", margin: "0" }}>
                        Lütfen sorunuzu, şıkları ve doğru cevabı eksiksiz bir şekilde doldurun.
                      </p>
                    </div>



                    <form
                      onSubmit={this.handleSubmit}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                          e.preventDefault();
                        }
                      }}
                    >
                      {/* Honeypot field for bot protection */}
                      <input
                        type="text"
                        name="honeypot"
                        value={honeypot}
                        onChange={this.handleInputChange}
                        style={{ display: "none" }}
                        autoComplete="off"
                      />

                      {/* Question List Accordion */}
                      <div style={{ marginBottom: "20px" }}>
                        {questions.map((q, idx) => {
                          const qPrefix = `q_${q.id}_`;
                          return (
                            <div
                              key={q.id}
                              id={`q_card_${q.id}`}
                              style={{
                                background: "#ffffff",
                                borderRadius: "16px",
                                padding: "24px",
                                marginBottom: "24px",
                                border: "1.5px solid #e2e8f0",
                                boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)",
                                position: "relative",
                              }}
                            >
                              {/* Accordion Header */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  userSelect: "none",
                                  paddingBottom: q.isOpen ? "20px" : "0px",
                                  borderBottom: q.isOpen ? "1px solid #e2e8f0" : "none",
                                }}
                                onClick={() => this.toggleQuestionOpen(q.id)}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                  <div
                                    style={{
                                      background: "#3b82f6",
                                      color: "white",
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontWeight: "700",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {idx + 1}
                                  </div>
                                  <span style={{ fontWeight: "600", fontSize: "16px", color: "#1e293b" }}>
                                    {q.question_text.trim()
                                      ? q.question_text.length > 60
                                        ? q.question_text.substring(0, 60) + "..."
                                        : q.question_text
                                      : `${idx + 1}. Soru`}
                                  </span>
                                </div>
                                <div
                                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {questions.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() => this.removeQuestion(q.id)}
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                        color: "#ef4444",
                                        cursor: "pointer",
                                        padding: "6px",
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "background 0.2s",
                                      }}
                                      onMouseEnter={(e) => (e.currentTarget.style.background = "#fee2e2")}
                                      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                      title="Bu soruyu sil"
                                    >
                                      <Trash2 size={18} />
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    onClick={() => this.toggleQuestionOpen(q.id)}
                                    style={{
                                      background: "transparent",
                                      border: "none",
                                      color: "#64748b",
                                      cursor: "pointer",
                                      padding: "6px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {q.isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                  </button>
                                </div>
                              </div>

                              {/* Accordion Body */}
                              {q.isOpen && (
                                <div className="row" style={{ marginTop: "24px" }}>

                                  {/* Question Text */}
                                  <div className="col-12 mb-20">
                                    <label
                                      style={{
                                        display: "block",
                                        marginBottom: "8px",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#374151",
                                      }}
                                    >
                                      Soru Metni *
                                    </label>
                                    <div style={{ position: "relative" }}>
                                      <textarea
                                        name="question_text"
                                        value={q.question_text}
                                        onChange={(e) => this.handleQuestionInputChange(q.id, e)}
                                        rows="3"
                                        placeholder="Lütfen hazırladığınız soruyu buraya yazın..."
                                        style={{
                                          width: "100%",
                                          padding: "14px 18px",
                                          border: "2px solid #e2e8f0",
                                          borderRadius: "12px",
                                          fontSize: "15px",
                                          resize: "none",
                                          minHeight: "80px",
                                        }}
                                      />
                                    </div>
                                    {errors[`${qPrefix}question_text`] && (
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          background: "#fef2f2",
                                          border: "1px solid #fee2e2",
                                          borderRadius: "8px",
                                          padding: "6px 12px",
                                          color: "#ef4444",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginTop: "8px",
                                          boxShadow: "0 1px 2px rgba(239, 68, 68, 0.03)",
                                        }}
                                      >
                                        <AlertCircle size={14} />
                                        {errors[`${qPrefix}question_text`]}
                                      </div>
                                    )}
                                  </div>

                                  {/* Info Alert for Correct Answer selection */}
                                  <div className="col-12" style={{ marginBottom: "25px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "10px 14px",
                                        background: "rgba(16, 185, 129, 0.08)",
                                        border: "1px dashed rgba(16, 185, 129, 0.3)",
                                        borderRadius: "8px",
                                        fontSize: "13px",
                                        color: "#065f46",
                                        fontWeight: "500",
                                      }}
                                    >
                                      <HelpCircle size={16} color="#10b981" />
                                      <span>Lütfen hazırladığınız şıkların sağındaki yuvarlak simgeye tıklayarak <strong>doğru cevabı</strong> seçin.</span>
                                    </div>
                                    {errors[`${qPrefix}correct_answer`] && (
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          background: "#fef2f2",
                                          border: "1px solid #fee2e2",
                                          borderRadius: "8px",
                                          padding: "6px 12px",
                                          color: "#ef4444",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginTop: "8px",
                                          boxShadow: "0 1px 2px rgba(239, 68, 68, 0.03)",
                                        }}
                                      >
                                        <AlertCircle size={14} />
                                        {errors[`${qPrefix}correct_answer`]}
                                      </div>
                                    )}
                                  </div>

                                  {/* Options */}
                                  {["a", "b", "c", "d"].map((opt) => {
                                    const fieldName = `option_${opt}`;
                                    const isCorrect = q.correct_answer === opt.toUpperCase();
                                    return (
                                      <div key={opt} className="col-md-6 mb-20">
                                        <label
                                          style={{
                                            display: "block",
                                            marginBottom: "8px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "#374151",
                                          }}
                                        >
                                          {opt.toUpperCase()} Şıkkı *
                                        </label>
                                        <div style={{ position: "relative" }}>
                                          <input
                                            type="text"
                                            name={fieldName}
                                            value={q[fieldName]}
                                            onChange={(e) => this.handleQuestionInputChange(q.id, e)}
                                            placeholder={`${opt.toUpperCase()} seçeneğinin metni`}
                                            style={{
                                              width: "100%",
                                              padding: "14px 50px 14px 18px",
                                              border: isCorrect
                                                ? "2px solid #10b981"
                                                : "2px solid #e2e8f0",
                                              borderRadius: "12px",
                                              fontSize: "15px",
                                              backgroundColor: isCorrect ? "#f0fdf4" : "#ffffff",
                                              transition: "all 0.2s ease",
                                            }}
                                          />
                                          <button
                                            type="button"
                                            onClick={() => this.handleSelectCorrectAnswer(q.id, opt.toUpperCase())}
                                            style={{
                                              position: "absolute",
                                              right: "14px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              background: "none",
                                              border: "none",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              padding: "4px",
                                              zIndex: 2,
                                              outline: "none",
                                            }}
                                            title={isCorrect ? "Doğru cevap olarak seçildi" : "Doğru cevap olarak seç"}
                                          >
                                            {isCorrect ? (
                                              <div
                                                style={{
                                                  width: "22px",
                                                  height: "22px",
                                                  borderRadius: "50%",
                                                  backgroundColor: "#10b981",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  boxShadow: "0 2px 4px rgba(16, 185, 129, 0.2)",
                                                }}
                                              >
                                                <Check size={13} color="#ffffff" strokeWidth={3.5} />
                                              </div>
                                            ) : (
                                              <div
                                                style={{
                                                  width: "22px",
                                                  height: "22px",
                                                  borderRadius: "50%",
                                                  border: "2px solid #9ca3af",
                                                  backgroundColor: "transparent",
                                                }}
                                              />
                                            )}
                                          </button>
                                        </div>
                                        {errors[`${qPrefix}${fieldName}`] && (
                                          <div
                                            style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "6px",
                                              background: "#fef2f2",
                                              border: "1px solid #fee2e2",
                                              borderRadius: "8px",
                                              padding: "6px 12px",
                                              color: "#ef4444",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginTop: "8px",
                                              boxShadow: "0 1px 2px rgba(239, 68, 68, 0.03)",
                                            }}
                                          >
                                            <AlertCircle size={14} />
                                            {errors[`${qPrefix}${fieldName}`]}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      {/* Add Question Button at Bottom */}
                      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "-10px", marginBottom: "25px" }}>
                        <button
                          type="button"
                          onClick={this.addQuestion}
                          style={{
                            background: "transparent",
                            border: "2px solid #3b82f6",
                            color: "#3b82f6",
                            borderRadius: "12px",
                            padding: "10px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            transition: "background 0.2s, color 0.2s",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#eff6ff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                          }}
                        >
                          <Plus size={16} />
                          Yeni Soru Ekle
                        </button>
                      </div>



                      <div className="row">
                        {/* Privacy Clarification Agreement */}
                        <div className="col-12" id="clarification_checkbox_container" style={{ marginBottom: "25px" }}>
                          <label
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "10px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#374151",
                              fontWeight: "500",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={agreedToClarification}
                              onChange={(e) =>
                                this.setState({
                                  agreedToClarification: e.target.checked,
                                  errors: {
                                    ...this.state.errors,
                                    agreedToClarification: "",
                                  },
                                })
                              }
                              style={{
                                width: "18px",
                                height: "18px",
                                marginTop: "2px",
                                cursor: "pointer",
                                accentColor: "#3b82f6",
                              }}
                            />
                            <span>
                              <a
                                href="/iletisim_formu_aydinlatma_metni"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#3b82f6",
                                  textDecoration: "underline",
                                  fontWeight: "600",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                İletişim Formu Aydınlatma Metni
                              </a>
                              'ni okudum ve kabul ediyorum. *
                            </span>
                          </label>
                           {errors.agreedToClarification && (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                background: "#fef2f2",
                                border: "1px solid #fecaca",
                                borderRadius: "8px",
                                padding: "8px 14px",
                                marginTop: "12px",
                                color: "#ef4444",
                                fontSize: "13px",
                                fontWeight: "600",
                                boxShadow: "0 2px 4px rgba(239, 68, 68, 0.05)",
                                lineHeight: "1.5",
                              }}
                            >
                              <AlertCircle size={15} />
                              {errors.agreedToClarification}
                            </div>
                          )}
                        </div>

                        {submitSuccess && (
                          <div className="col-12" style={{ marginTop: "15px", marginBottom: "15px" }}>
                            <div
                              style={{
                                background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
                                border: "1px solid #10b981",
                                borderRadius: "14px",
                                padding: "16px 20px",
                                color: "#065f46",
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <CheckCircle size={20} />
                              Örnek sorunuz başarıyla alındı! İnceleme sonrasında uygun görülürse sisteme eklenecektir. Katkınız için teşekkür ederiz.
                            </div>
                          </div>
                        )}

                        {submitError && (
                          <div className="col-12" style={{ marginTop: "25px", marginBottom: "15px" }}>
                            <div
                              style={{
                                background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
                                border: "1px solid #ef4444",
                                borderRadius: "14px",
                                padding: "16px 20px",
                                color: "#991b1b",
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <AlertCircle size={20} />
                              {submitError}
                            </div>
                          </div>
                        )}

                        {cooldownSeconds > 0 && (
                          <div className="col-12" style={{ marginTop: "25px", marginBottom: "15px" }}>
                            <div
                              style={{
                                background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                                border: "1px solid #f59e0b",
                                borderRadius: "14px",
                                padding: "16px 20px",
                                color: "#92400e",
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                boxShadow: "0 4px 6px -1px rgba(245, 158, 11, 0.05)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f59e0b",
                                  borderRadius: "50%",
                                  width: "28px",
                                  height: "28px",
                                  color: "white"
                                }}
                              >
                                <RotateCw size={16} style={{ animation: "spin 4s linear infinite" }} />
                              </div>
                              <div style={{ flex: 1 }}>
                                <span style={{ display: "block", fontSize: "14px" }}>
                                  1 dakikada en fazla 2 soru gönderebilirsiniz. 
                                </span>
                                <span style={{ fontSize: "13px", color: "#b45309", fontWeight: "500" }}>
                                  Yeni soru göndermek için kalan süre: <strong>{cooldownSeconds} saniye</strong>
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Submit Button */}
                        <div className="col-12" style={{ marginTop: "20px" }}>
                          <button
                            type="submit"
                            disabled={isSubmitting || cooldownSeconds > 0 || !hasAnyInput}
                            style={{
                              background: (isSubmitting || cooldownSeconds > 0 || !hasAnyInput)
                                ? "#e2e8f0"
                                : "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                              color: (isSubmitting || cooldownSeconds > 0 || !hasAnyInput) ? "#94a3b8" : "white",
                              padding: "16px 40px",
                              border: "none",
                              borderRadius: "12px",
                              fontSize: "16px",
                              fontWeight: "700",
                              cursor: (isSubmitting || cooldownSeconds > 0 || !hasAnyInput) ? "not-allowed" : "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              justifyContent: "center",
                              width: "100%",
                              boxShadow: (isSubmitting || cooldownSeconds > 0 || !hasAnyInput) ? "none" : "0 10px 25px rgba(59, 130, 246, 0.2)",
                              transition: "transform 0.2s, box-shadow 0.2s",
                            }}
                          >
                            {isSubmitting ? (
                              <>
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #ffffff",
                                    borderTop: "2px solid transparent",
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite",
                                  }}
                                />
                                Gönderiliyor...
                              </>
                            ) : cooldownSeconds > 0 ? (
                              <>
                                <RotateCw size={18} style={{ animation: "spin 10s linear infinite" }} />
                                Limit Doldu ({cooldownSeconds}sn)
                              </>
                            ) : !hasAnyInput ? (
                              <>
                                <Send size={18} />
                                Lütfen Formu Doldurun
                              </>
                            ) : (
                              <>
                                <Send size={18} />
                                Örnek Soruyu Gönder
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </>
    );
  }
}
